import React, { useEffect, useState, useMemo, useContext } from "react";
import axios from "axios";
import Select from "react-select";
import { Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { AppContext } from "../../../context/AppContext";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { Box } from "@mui/material";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const VendorBalanceSummary = (props) => {
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    ReportViewPermission,
    currencySymbolLocation,
  } = useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(1);
  const [agingMethod, setAgingMethod] = useState("Current");
  const [classicView, setClassicView] = useState(true);

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });
  }, []);

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/vendorbalancesummary?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&locationid=${locationid}&agingmethod=${agingMethod}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          const FilterData = res.data.ResponseData?.map((el) => ({
            ...el,
            Balance: Number(el?.Balance),
            CustomerName: String(el?.CustomerName ?? ""),
          }));
          setResponseData(FilterData);
          setTotalSum(
            FilterData.reduce(
              (sum, item) => sum + (parseFloat(item.Balance) || 0),
              0
            )
          );
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const columns = useMemo(() => [
    {
      header: "Supplier Name",
      accessorKey: "SupplierName",
      filterFn: "contains",
    },
    {
      header: "Balance",
      accessorKey: "Balance",
      filterFn: "contains",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            textAlign: "end",
            alignItems: "center",
            fontWeight: "700",
          }}
          onClick={() =>
            window.open(
              `/vendor-balance-detail?suptid=${row.original.SupplierID}&startdate=${startdate}&enddate=${enddate}&selectedperiod=${selectReport}&agingmethod=${agingMethod}`,
              "_blank"
            )
          }
        >
          {CurrencySymbols(
            Number(row.original.Balance),
            { CurrencySymbol },
            FractionDigits
          )}
        </Box>
      ),
    },
  ]);


  const Classiccolumns = [
    {
      title: "Supplier Name",
      field: "SupplierName",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
      width: "50%",
    },

    {
      title: "Balance",
      field: "Balance",
      headerFilter: "input",
      bottomCalc: "sum",
      width: "50%",
      defaultVisible: true,

      // Top Total Formatter (if grouping has topCalc)
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },

      // Bottom Total Formatter (for group sum row)
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },

      // Cell content with span and class for styling
      formatter: function (cell) {
        const value = cell.getValue();
        const row = cell.getRow().getData();

        if (value == "0.00" || value === "") {
          return `<span class="clickable-balance" style="text-decoration: underline; text-underline-offset: 3px; font-weight: bold;">${CurrencySymbol}0.0</span>`;
        }

        const formattedValue = Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );

        return `<span class="clickable-balance" style="text-decoration: underline; text-underline-offset: 3px; font-weight: bold;">${formattedValue}</span>`;
      },

      // Handle click
      cellClick: function (e, cell) {
        const rowData = cell.getRow().getData();

        // Ensure needed fields exist
        if (rowData?.SupplierID) {
          const url = `/vendor-balance-detail?suptid=${rowData.SupplierID}&startdate=${startdate}&enddate=${enddate}&selectedperiod=${selectReport}&agingmethod=${agingMethod}`;
          window.open(url, "_blank");
        }
      },
    },
  ];

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Vendor Balance Summary
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                  showasofdate={true}
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Aging Method
              </label>
              <div className="row">
                <div className="col-6">
                  <input
                    type="radio"
                    name="day"
                    checked={agingMethod == "Current"}
                    onChange={(e) =>
                      setAgingMethod(
                        e.target.checked ? "Current" : "ReportDate"
                      )
                    }
                  />
                  <label className="col-form-label form-label p-lg-medium ms-2">
                    Current
                  </label>
                </div>
                <div className="col-6">
                  <input
                    type="radio"
                    name="day"
                    checked={agingMethod == "ReportDate"}
                    onChange={(e) =>
                      setAgingMethod(
                        e.target.checked ? "ReportDate" : "Current"
                      )
                    }
                  />
                  <label className="col-form-label form-label p-lg-medium ms-2">
                    Report Date
                  </label>
                </div>
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>

          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 className="p">SonarPos</h6>
                    <p className="fw-bold p-regular">Vendor Balance Summary</p>
                    <div className="row mb-2 p-regular">
                      <p>
                        {/* Date:{" "} */}
                        {enddate === ""
                          ? "All Data"
                          : "As of " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  {ReportViewPermission == true ? (
                    <button
                      className="btn btn-secondary"
                      onClick={() => setClassicView(!classicView)}
                    >
                      {" "}
                      {classicView ? "Classic View" : "Morden View"}
                    </button>
                  ) : (
                    <></>
                  )}
                  {classicView ? (
                    <CommonTabular
                      Data={responseData}
                      columns={Classiccolumns}
                      Groupvalue={[]}
                      Reportname={"Vendor Balance Summary"}
                      frozenRowvalue={0}
                      // layout={"fitDataFill"}
                      Onrefresh={() => apicall()}
                    />
                  ) : (
                    <CommonMatrialReactTable
                      MainHeading="Sonar POS"
                      ReportHeading="Vendor Balance Summary"
                      columns={columns}
                      data={responseData}
                      startdate={startdate}
                      enddate={enddate}
                      columnGrouping={[]}
                      columnsVisibility={{}}
                      enableRowSelection={false}
                    />
                  )}
                </div>
                <div style={{ textAlign: "right" }} className=" mt-5 ">
                  <p class="text-right p-medium">
                    Total Amount:{" "}
                    {CurrencySymbols(
                      Number(totalSum),
                      { CurrencySymbol },
                      FractionDigits
                    )}
                  </p>
                  <hr
                    style={{
                      display: "inline-block",
                      borderBottom: "3px solid black",
                      width: "30%",
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default VendorBalanceSummary;
